import SmartAuthForm from "@/features/auth/components/SmartAuthForm";
import { AuthPageHeader } from "@/features/auth/components/layout";
import { useAuthCopy } from "@/features/i18n/authCopy";

export function AuthErrorPage({ resetAuthError }: { resetAuthError: () => void }) {
    const copy = useAuthCopy();

    return (
        <>
            <AuthPageHeader title={copy.linkExpiredTitle} description={copy.smartAuthHint} />
            <SmartAuthForm onSuccess={resetAuthError} />
        </>
    );
}
